import {RecurringPaymentStatus, StudentRecurringPayment} from "types/student-account/student-payment"

export const hasActiveRecurringPaymentForPlan = (
    recurringPayments: StudentRecurringPayment[],
    paymentPlanId?: number | null
): boolean => {
    if (!paymentPlanId) return false
    return recurringPayments.some(
        (payment) =>
            payment.status === RecurringPaymentStatus.Active &&
            payment.paymentPlanItems?.some((item) => item.paymentPlanId === paymentPlanId)
    )
}

// Unlike hasActiveRecurringPaymentForPlan (true for every item on a plan that has any active
// recurring payment), this only matches the specific item(s) a recurring payment is currently
// linked to and about to bill next — used to show "In Progress" on just the upcoming charge
// instead of every unpaid item on the plan.
export const isPaymentPlanItemUpNextForRecurring = (
    recurringPayments: StudentRecurringPayment[],
    paymentPlanItemId?: number | null
): boolean => {
    if (!paymentPlanItemId) return false
    return recurringPayments.some(
        (payment) =>
            payment.status === RecurringPaymentStatus.Active &&
            payment.paymentPlanItems?.some((item) => item.paymentPlanItemId === paymentPlanItemId)
    )
}
